import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetTrainerVerification = async (keyword = '', page = '', perPage = '', is_paginate = 1,email = false) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['keyword'] = keyword;
    }

    if(is_paginate === 1){
        params['paginate'] = is_paginate;
    }


    const response = await GET(apiUrl.training_verification, params);
    return response;
}

export const GetTrainerVerificationById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.training_verification + '/' + id,params);
    return response;
}

export const CreateTrainerVerification = async (data) => {
    const response = await POST(apiUrl.training_verification, data);
    return response;
}

export const UpdateTrainerVerification = async (id, data) => {
    const response = await PUT(apiUrl.training_verification, id, data);
    return response;
}

export const DeleteTrainerVerification = async (id) => {
    const response = await DELETE(apiUrl.training_verification, id);
    return response;
}
